import dayjs from 'dayjs'
import { DATE_FORMAT } from 'constants/locale'

export function nowDateMinusOneMonth () { return dayjs().subtract(1, 'month').format(DATE_FORMAT) }

export function nowDatePlusOneDay () { return dayjs().add(1, 'day').format(DATE_FORMAT) }

export function flatMappedStories (group) {
  return group.reduce((acc, node) => !node.groupSource
    ? null
    : acc.concat(node.groupSource.getValue().map(story => {
      return { ...story, publishDate: node.title }
    })), [])
}
